
import { DbInfo } from "@/models/db-info";
import { MetricService } from "@/services/metric-service";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			availableDbs: [] as DbInfo[]
		};
	},
	async mounted(){
		this.availableDbs = await MetricService.getAllDbIds();
	}
});
